import { app } from 'app/app';
import { AppController } from 'app/controller';
import { MasterLayout } from 'layout/master/main';
import { SalaryBenchmarkForm } from 'module/salaryBenchmarkForm/main';
import 'module/hero/main';
import 'module/hr/main';
import 'module/teaserList/main';
import { ArticleCardSlider } from 'module/articleCardSlider/main';
import './styles.scss';

class SalaryBenchmarkIndex extends AppController {
    domBindings() {
        return {
            articleCardSlider: '.m-articleCardSlider',
            salaryBenchmarkForm: '.m-salaryBenchmarkForm',
        };
    }

    subs() {
        this.layout = new MasterLayout(document.documentElement);
        this.articleCardSlider = new ArticleCardSlider(this.dom.articleCardSlider);
        this.salaryBenchmarkForm = new SalaryBenchmarkForm(this.dom.salaryBenchmarkForm);
    }
}

app.boot(SalaryBenchmarkIndex);

if (module.hot) {
    module.hot.accept(module.children, () => {
        // eslint-disable-next-line no-console
        console.log('Rebooting controller due to HMR...');
        app.boot(SalaryBenchmarkIndex);
    });

    module.hot.accept(() => {});
}
